<div bsModal
     class="modal fade"
     (onShown)="isShown = true"
     (onHidden)="isShown = false"
     tabindex="-1"
     [config]="{backdrop: 'static'}"
     role="dialog"
     aria-labelledby="dialog-sizes-name1">
    <div class="modal-dialog modal-confirm modal-xl">
        <div class="modal-content">
            <div class="modal-body">
                <app-map-picker [(location)]="location"
                                [mapView]="mapView"
                                [zoomLevel]="zoomLevel"
                                *ngIf="isShown"></app-map-picker>
                <div class="row">
                    <div class="col-12 form-inline mt-3">
                        <div class="form-group mb-2">
                            <label class="mr-3">Latitude</label>
                            <input type="text"
                                   [ngModel]="location?.lat"
                                   [ngModelOptions]="{updateOn: 'blur'}"
                                   (ngModelChange)="lat = $event; setMapViewToLocation()"
                                   class="form-control mr-3">
                        </div>
                        <div class="form-group mb-2">
                            <label class="mr-3">Longitude</label>
                            <input type="text"
                                   [ngModel]="location?.lng"
                                   [ngModelOptions]="{updateOn: 'blur'}"
                                   (ngModelChange)="lon = $event; setMapViewToLocation()"
                                   class="form-control">
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary" aria-label="Close" (click)="update()">
                    Update
                </button>
                <button type="button"
                        class="btn btn-outline-dark"
                        aria-label="Close"
                        (click)="cancel()">Cancel
                </button>
            </div>
        </div>
    </div>
</div>
